module.exports = __webpack_public_path__ + "img/icon_wy12.5a2321e7.png";